var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTravellers = function SvgTravellers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#FFF",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5,7 C6.43299662,7 8,8.56700338 8,10.5 L8,14 L1,14 L1,10.5 C1,8.56700338 2.56700338,7 4.5,7 Z M10.5002944,9 C11.8810062,9 13.0002944,10.1192881 13.0002944,11.5 L13.0002944,14 L9.50029435,13.9997654 L9.50029435,10.5057654 C9.50029435,10.083454 9.48261395,9.6733711 9.38403764,9.28165365 C9.72780691,9.10132075 10.0848802,9 10.5002944,9 Z M10.5242101,4 C11.6287796,4 12.5242101,4.8954305 12.5242101,6 C12.5242101,7.1045695 11.6287796,8 10.5242101,8 C9.41964058,8 8.52421008,7.1045695 8.52421008,6 C8.52421008,4.8954305 9.41964058,4 10.5242101,4 Z M4.5,1 C5.88071187,1 7,2.11928813 7,3.5 C7,4.88071187 5.88071187,6 4.5,6 C3.11928813,6 2,4.88071187 2,3.5 C2,2.11928813 3.11928813,1 4.5,1 Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTravellers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/travellers.8e90ef3b.svg";
export { ForwardRef as ReactComponent };